import store from '../../store/index.js'
import { COMMON_AUTH_PAGE_URL } from '../../util/URL'
import { isIAnHiddenCompany } from '../../util/tools'
import authApiClient from '../../api/auth-api-client'
import router from '../index'

export const authGuard = async (to, from, next) => {
  if (to.path === '/access-denied') {
    next()
    return
  }

  /**
   * If we have query param "token" in the url,
   * we were redirected from "hvd common auth" and have
   * to update / set the new token.
   *
   *
   */
  //const url = new URL(window.location)
  //const url = new URL(to.fullPath)

  const tokenFromLS = localStorage.getItem('user-auth-token')
  //const tokenFromUrl = url.searchParams.get('token')

  const tokenFromUrl = to.query.token
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (!isAuthenticated) {
    if (tokenFromUrl || tokenFromLS) {
      try {
        await store.dispatch('auth/setToken', { token: tokenFromUrl || tokenFromLS })
        await store.dispatch('init')
        to.query.token = undefined
        next({ path: to.path, query: to.query })
      } catch (error) {
        if (error.code === 'ACCESS_DENIED') {
          next('/access-denied')
        } else {
          store.dispatch('auth/logout')
        }
      }
    } else {
      store.dispatch('auth/logout')
    }
  } else if (isAuthenticated && tokenFromUrl) {
    window.history.pushState({}, 'redirpath', to.fullPath)
  } else {
    /**
     * When user inputs url to browser's address row
     *
     * Check what's the current company and relogin if that differs from company where they are trying to access
     */

    if (to.path.includes('/company/')) {
      const userCompany = store.getters['user/getUserCompany']
      const navigateToCompany = parseInt(to.path.split('/')[2])

      try {
        const response = await authApiClient.get(
          `Authentication/availablecompanies?Filter=companyId=${navigateToCompany}`,
        )
        const hasAccess = response.data.data.length > 0

        if (!hasAccess) {
          console.log('User does not have access to this company')
          router.push('/companies').catch(() => {})
          return
        }

        if (userCompany !== navigateToCompany && !isIAnHiddenCompany()) {
          try {
            const deviceId = localStorage.getItem('deviceId')
            const ctxResponse = await authApiClient.post('Authentication/changecontext', {
              authContext: {
                companyId: navigateToCompany,
              },
              deviceId,
            })

            if (ctxResponse.data?.token) {
              await store.dispatch('auth/setToken', { token: ctxResponse.data.token })
              await store.dispatch('init')

              if (to.query.token) {
                next({ path: to.path, query: { ...to.query, token: undefined } })
              } else {
                next()
              }
            } else {
              // Fallback to legacy full redirect if backend did not supply token
              let currentPath = window.location.origin
              window.location.href =
                COMMON_AUTH_PAGE_URL +
                btoa(currentPath + to.fullPath) +
                '&token=' +
                store.state.auth.token +
                '&companyId=' +
                navigateToCompany
            }
          } catch (err) {
            console.error('changecontext failed, falling back to redirect', err)
            let currentPath = window.location.origin
            window.location.href =
              COMMON_AUTH_PAGE_URL +
              btoa(currentPath + to.fullPath) +
              '&token=' +
              store.state.auth.token +
              '&companyId=' +
              navigateToCompany
          }
        } else {
          next()
        }
      } catch (error) {
        console.log('Error checking company access:', error)
        if (error.response?.status === 404 || error.response?.status === 403) {
          router.push('/companies').catch(() => {})
          return
        }
        next()
      }
    } else {
      next()
    }
  }
}
